// extracted by mini-css-extract-plugin
export default {"wrapper":"HorseEditModal_wrapper__K5-0F","icon":"HorseEditModal_icon__+l0xV","heading":"HorseEditModal_heading__L+QOA"};